export enum ActorInvitationReason {
  DISABLED_BY_POLICY = "DISABLED_BY_POLICY",
  UNSUPPORTED_ACTOR_TYPE_FOR_INVITATION = "UNSUPPORTED_ACTOR_TYPE_FOR_INVITATION",
  MAX_TOTAL_ACTORS_REACHED = "MAX_TOTAL_ACTORS_REACHED",
}

export type ActorInvitation = {
  enabled: boolean;
  reason: ActorInvitationReason | null;
};
